import { render, staticRenderFns } from "./ProductSearchInput.vue?vue&type=template&id=2d863cd4"
import script from "./ProductSearchInput.vue?vue&type=script&lang=js"
export * from "./ProductSearchInput.vue?vue&type=script&lang=js"
import style0 from "./ProductSearchInput.vue?vue&type=style&index=0&id=2d863cd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports